const webNotificationsKeys = {
  all: ["webNotifications"],
  list: () => [...webNotificationsKeys.all, "list"],
};

export default webNotificationsKeys;
